import HeaderHamburgerMenu from './components/header/_headerHamburgerMenu';
import HeaderHeight from './components/header/_headerHeight';
import HeaderMegaMenu from './components/header/_headerMegaMenu';

/**
 * DOMContentLoaded とは
 * ページの読み込みが完了した時に発生するイベント
 * このイベントが発生した時に初期化処理を行う
 */
document.addEventListener('DOMContentLoaded', () => {
  // headerHeight
  const headerHeight = new HeaderHeight();

  // headerMegaMenu
  const headerMegaMenu = new HeaderMegaMenu();

  // headerHamburgerMenu
  const headerHamburgerMenu = new HeaderHamburgerMenu();
});
